import { render, staticRenderFns } from "./DocType.vue?vue&type=template&id=ca15fa1c"
import script from "./DocType.vue?vue&type=script&lang=js"
export * from "./DocType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports